import { Description, Field, Label, Switch } from '@headlessui/react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import Skeleton from 'react-loading-skeleton'

/**
 * Schalter für die Kopfzeilen der Auswertungen in Discover. Field und Label
 * geben dem Switch einen zugänglichen Namen, ein Klick aufs Label schaltet um.
 * Ist er deaktiviert, erklärt disabledReason warum, sichtbar per title am
 * Wrapper und für Screenreader als Description.
 */
export default function DiscoverSwitch({
  label,
  checked,
  onChange,
  disabled = false,
  disabledReason,
  isLoading = false,
  className
}) {
  if (isLoading) {
    return (
      <div className={clsx('flex flex-row items-center gap-x-2', className)}>
        <Skeleton width={150} />
        <Skeleton width={40} height={24} />
      </div>
    )
  }

  return (
    <Field
      disabled={disabled}
      title={disabled ? disabledReason : undefined}
      className={clsx('flex flex-row items-center gap-x-2', className)}
    >
      <Label
        className={clsx(
          'text-sm text-rockGrey',
          disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'
        )}
      >
        {label}
      </Label>
      {disabled && disabledReason && (
        <Description className='sr-only'>{disabledReason}</Description>
      )}
      <Switch
        checked={checked}
        onChange={onChange}
        className={clsx(
          'group relative inline-flex h-6 w-11 flex-shrink-0 items-center rounded-full transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-primaryBlue focus-visible:ring-offset-2',
          checked ? 'bg-primaryBlue' : 'bg-mediumGrey',
          disabled && 'cursor-not-allowed opacity-50'
        )}
      >
        <span
          aria-hidden='true'
          className={clsx(
            'inline-block h-4 w-4 transform rounded-full bg-white transition-transform',
            checked ? 'translate-x-6' : 'translate-x-1'
          )}
        />
      </Switch>
    </Field>
  )
}

DiscoverSwitch.propTypes = {
  label: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  disabledReason: PropTypes.string,
  isLoading: PropTypes.bool,
  className: PropTypes.string
}
